import logo from './logo.svg';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import LandingPage from './pages/landing';
import PrivacyPolicy from './pages/privacyPolicy';
import TermsAndServices from './pages/termsAndServices';

function App() {
  return (
    <Router>
      
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-services" element={<TermsAndServices />} />
        </Routes>
      
    </Router>
  );
}

export default App;
